/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { CommandLinkRel, CommandResource } from '@alfa-client/command-shared';
import { HasLinkPipe } from '@common/tech-shared';
import { Component, input } from '@angular/core';
import { DateComponent, IconComponent } from '@ods/system';
import { UserProfileInHistorieContainerComponent } from '../user-profile-in-historie-container/user-profile-in-historie-container.component';

@Component({
  selector: 'alfa-historie-item-header',
  templateUrl: './historie-item-header.component.html',
  styleUrls: ['./historie-item-header.component.scss'],
  imports: [HasLinkPipe, IconComponent, DateComponent, UserProfileInHistorieContainerComponent],
})
export class HistorieItemHeaderComponent {
  readonly headline = input<string>();
  readonly resource = input.required<CommandResource>();

  readonly commandLinkRel = CommandLinkRel;
}
